import React, { Component } from 'react';
import classNames from 'classnames';
import DragObserver from '../drag-observer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Coord, SeparatorProps, SeparatorState } from './types';

// eslint-disable-next-line jira/react/no-class-components
class Separator extends Component<SeparatorProps, SeparatorState> {
	state = {
		isMouseHover: false,
	};

	onDragStart = () => this.props.onDragStart(this.props.index);

	onDrag = (from: Coord, to: Coord) => this.props.onDrag({ index: this.props.index, from, to });

	onDragEnd = () => {
		const { isActive, onDragEnd, setActiveSeparator } = this.props;
		onDragEnd();
		if (isActive && !this.state.isMouseHover) {
			setActiveSeparator(null);
		}
	};

	onMouseEnter = () => {
		this.setState({ isMouseHover: true });
		const { index, isActive, isDragging, setActiveSeparator } = this.props;
		if (!isActive && !isDragging) {
			setActiveSeparator(index);
		}
	};

	onMouseLeave = () => {
		this.setState({ isMouseHover: false });
		// Deferring isDragging check as mouse leave could happen before isDragging was propagated
		// back to this component if user moves cursor too fast.
		setTimeout(() => {
			const { isDragging, setActiveSeparator } = this.props;
			if (!isDragging) {
				setActiveSeparator(null);
			}
		}, 50);
	};

	render() {
		const separatorClassName = classNames(styles.handle, {
			[styles['drag-active']]: this.props.isActive,
		});
		return (
			<DragObserver
				dragHandler={{
					onDragStart: this.onDragStart,
					onDrag: this.onDrag,
					onDragEnd: this.onDragEnd,
				}}
			>
				<div
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					className={styles.separator}
					data-testid={this.props.testId || ''}
					role="none"
					onMouseEnter={this.onMouseEnter}
					onMouseLeave={this.onMouseLeave}
				>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<div className={separatorClassName} />
				</div>
			</DragObserver>
		);
	}
}

export default Separator;
